module.exports = "/_next/static/images/ad36cba3471563aafe324236d7fb7753-perks-xs-2x.jpg";